module.exports = __webpack_public_path__ + "static/media/Hai_Logo.e9d1beb3.svg";